<template>
  <header class="items-center py-2 mx-auto max-w-screen-xl">
    <div
      class="gap-6 items-center py-8 px-4 mx-auto max-w-screen-xl flex flex-col text-center justify-center lg:py-16 lg:px-6"
    >
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
          Unsere Highlights
        </h2>
        <div class="mb-4 grid lg:grid-cols-3 gap-4 grid-cols-1">
          <div
            v-for="(highlight, index) in highlights"
            :key="index"
            class="p-4 rounded-lg shadow-lg bg-gray-100 border-gray-200 border"
          >
            <img
              :src="highlight.image"
              :alt="`Bild von ${highlight.title}`"
              class="w-full h-46 object-cover rounded mb-3"
            />
            <h3 class="text-2xl font-semibold text-gray-900 mb-2">
              {{ highlight.title }}
            </h3>
            <p class="sm:h-24 lg:h-40">{{ highlight.description }}</p>
            <NuxtLink
              class="button mt-3"
              type="button"
              to="/presale#presale-form"
            >
              Jetzt reservieren
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import ArenaNostalgica from "@/assets/images/arena-nostalgica.jpg";
import Falschgeld from "@/assets/images/falschgeld.jpg";
import Hexagon from "@/assets/images/hexagon.jpeg";

type Highlight = {
  title: string;
  description: string;
  image: string;
};

const highlights: Highlight[] = [
  {
    title: "Arena Nostalgica",
    description:
      "Die Arena Nostalgica vereint am 19.07. um 19 Uhr die Highlights aus 34 Jahren Circus St. Ottilien mit den besten Nummern von 2025 in einer besonderen Sommerabendshow.",
    image: ArenaNostalgica,
  },
  {
    title: "Hexagon",
    description:
      "Das Hexagon Percussion Ensemble kehrt am 23.07. mit einer mitreißenden Drumshow und spektakulären Rhythmen zurück ins Circuszelt",
    image: Hexagon,
  },
  {
    title: "Falschgeld",
    description:
      "Die Münchner Indierockband Falschgeld bringt am 17.07. Stimmung ins Zelt und eröffnet die Circuswoche mit einem energiegeladenen Konzert.",
    image: Falschgeld,
  },
];
</script>
